import { useEffect, useState } from 'react';
import { parseJSON } from '@helpers/data';

export const useStoreInit = () => {
    const [stores, setStores] = useState(null);

    const intStore = () => {
        const storeData = parseJSON(App.Config.stores, []).reduce((accumulator, currentValue, currentIndex) => {
            accumulator[currentIndex] = {
                ...currentValue,
                icon: `flag_${currentValue.slug}`,
                children: []
            };

            return accumulator;
        }, {});
        setStores(storeData);
    };

    useEffect(() => {
        intStore();
    }, []);

    return stores;
};
